import { Redirect } from 'react-router-dom';
import FuseUtils from '@fuse/utils';
import LoginConfig from 'app/admin/login/LoginConfig';
import LogoutConfig from 'app/admin/logout/LogoutConfig';
import PasswordConfig from 'app/admin/password/PasswordConfig';
import AdminConfig from 'app/admin/AdminConfig';
import RoleRedirect from 'app/fuse-configs/RoleRedirect';

const routeConfigs = [LoginConfig, LogoutConfig, PasswordConfig, AdminConfig];

const routes = [
	...FuseUtils.generateRoutesFromConfigs(routeConfigs),
	{
		path: '/',
		exact: true,
		component: RoleRedirect
	}
];

export default routes;
